import styled from '@emotion/styled'
import { css } from '@emotion/react'

import env from '@/lib/env'

const Container = styled.section`
  & {
    background-image: url('${
      env.BASE_PATH
    }/static/images/welcome-double-exposure-business-man-partner-handshake/welcome-double-exposure-business-man-partner-handshake.jpg');
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    width: 100%;
    position: relative;
  }

  .container {
    width: ${({ theme }) => theme.size.width[90]};
    max-width: ${({ theme }) => theme.size.width[900]};
    height: auto;
    padding: 187px 0;
    margin: auto;
    display: flex;
    justify-content: flex-start;
    align-items: stretch;
    flex-flow: column nowrap;
    position: relative;
  }

  .decorator-container {
    overflow: visible;
  }

  #group-42 {
    position: absolute;
    top: 0;
    left: 0;
    height: 15%;
    transform: translate3d(-30%, -40%, 0);
    overflow: visible;
  }

  #group-379 {
    position: absolute;
    top: 0;
    right: 0;
    width: 20%;
    max-width: 300px;
    transform: translate3d(0%, -60%, 0);
    overflow: visible;
    transform-origin: bottom right;
  }

  ${({ theme }) =>
    css(
      theme.size.mq({
        '.container': {
          padding: ['97px 0', '97px 0', '97px 0', '187px 0'],
        },
        '#group-42': {
          display: ['none', 'none', 'block', 'block'],
        },
        '#group-379': {
          display: ['none', 'none', 'block', 'block'],
        },
      }),
    ).styles}}
`

export default Container
